var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.668,
    cy: 20,
    r: 20,
    fill: "#FFEBC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6689 14.9688C37.3023 14.9689 44.3096 21.9769 44.3096 30.6104C44.3094 39.2436 37.3022 46.2508 28.6689 46.251C20.0355 46.251 13.0275 39.2437 13.0273 30.6104C13.0273 21.9768 20.0354 14.9688 28.6689 14.9688Z",
    stroke: "#395966",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0467 10.2343C21.8228 9.98439 21.7109 9.67463 21.7109 9.305C21.7109 8.93508 21.8228 8.62518 22.0467 8.37528C22.2702 8.12509 22.5473 8 22.878 8H35.3265C35.6572 8 35.9343 8.1248 36.1578 8.37441C36.3816 8.62431 36.4935 8.93407 36.4935 9.30369C36.4935 9.67361 36.3816 9.98366 36.1578 10.2339C35.9343 10.4837 35.6572 10.6087 35.3265 10.6087H22.878C22.5473 10.6087 22.2702 10.4839 22.0467 10.2343Z",
    fill: "#395966"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8008 20.609C27.8008 19.8887 28.3848 19.3047 29.1051 19.3047C29.8255 19.3047 30.4095 19.8887 30.4095 20.609V30.1743C30.4095 30.8946 29.8255 31.4786 29.1051 31.4786C28.3848 31.4786 27.8008 30.8946 27.8008 30.1743V20.609Z",
    fill: "#FCBE1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.d75cc7178be9a60aa766c8d0f513991d.svg";
export { ForwardRef as ReactComponent };